import { render, staticRenderFns } from "./RegresarEtapa.vue?vue&type=template&id=f70610f4&"
import script from "./RegresarEtapa.vue?vue&type=script&lang=js&"
export * from "./RegresarEtapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports